export default __webpack_public_path__ + "static/media/7.9c942ff9.png";